// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line-loader[data-v-ecab3836]{\n  height:2px;\n  animation:lineLoader-ecab3836 4s linear infinite;\n  transition:ease;\n  margin:auto\n}\n@keyframes lineLoader-ecab3836{\n0%{\n    background:#dee5f9;\n    opacity:.8;\n    width:20%\n}\n40%{\n    opacity:1;\n    background:#2fd9b3;\n    width:100%\n}\nto{\n    opacity:.8;\n    background:#dee5f9;\n    width:20%\n}\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
